export const globalActionTypes = {
    init: "INIT",
    generalClear: "GENERAL_CLEAR"
};

export const generalClearAction = () => {
    return {
        type: globalActionTypes.generalClear
    };
};